<app-common-modal [alignTitleCenter]="true">
  <div
    class="user-account-is-deactivated-warning header grid-container-content-horizontal-center"
    modalHeader
  >
    <div class="mat-body-1 m-0 font-weight-medium">Account deactivated</div>
  </div>
  <div class="user-account-is-deactivated-warning content">
    <p class="m-0 sub-text">
      This account isn't currently active.
      <br />
      Please contact <a href="mailto:hello@sleip.com">hello&#64;sleip.com</a> to
      reactivate.
    </p>
  </div>
  <div class="user-account-is-deactivated-warning" modalFooterActions>
    <button
      class="sleip-tertiary-button large-size-button button-no-hover-effect button-block"
      (click)="onCancel()"
      mat-flat-button
    >
      Close
    </button>
  </div>
</app-common-modal>
